import { cronDelete, cronList, cronSet, getActiveProcess, getAllProcess, getLog, loadParams, masterAutomation, runManual } from "api/automation.api";


class automationClientClass {
    async masterList() {
        try {
            const { data } = await masterAutomation()

            return { data: data.data }
        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    async cronListClient() {
        try {
            const { data } = await cronList()

            return { data: data.data }
        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    async runManualClient(formData) {
        try {
            const { data } = await runManual(formData)

            return { data: data.data }
        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    async updateCreateCron(formData) {
        try {
            const { data } = await cronSet(formData)

            return { data: data.data }
        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    async destroy(automationName) {
        try {
            const { data } = await cronDelete(automationName)

            return { data: data.data }
        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    
    async getLogActomationName(automationName, processId) {
        try{
            if(!processId||!automationName){
                return {error:"some field are missing"}
            }
            const {data}= await getLog(processId, automationName)
            console.log(data)
            return {data}
        }catch(error){
            return {error}
        }
    }

    async getActiveProcessAction(automationName) {
        try{
            const {data}= await getActiveProcess(automationName)
            console.log(data)
            return data
        }catch(error){
            return {error}
        }
    }
    
    async getAllAction(automationName) {
        try{
            const {data}= await getAllProcess(automationName)
            console.log(data)
            return data
        }catch(error){
            return {error}
        }
    }


    async loadParamsAction(automationName) {
        try{
            const {data}= await loadParams({automationName})
            console.log(data)
            return data
        }catch(error){
            return {error}
        }
    }

}


const automationClient = new automationClientClass();

export default automationClient;